import type { PersonTypeRulesApi } from "../../api/PersonTypeRulesApi";
import type { PersonRef } from "../../generated/dto/PersonRef";
import type { PersonTypeMask } from "../../generated/dto/PersonTypeMask";
import type { PersonTypeRulesValidatePersonRequest } from "../../generated/dto/PersonTypeRulesValidatePersonRequest";
import type { PersonTypeValidation } from "../../generated/dto/PersonTypeValidation";

export class PersonTypeRulesFrontendService {
  constructor(private readonly api: PersonTypeRulesApi) {}
  async masksPublic(): Promise<Array<PersonTypeMask>> {
    return this.api.masksPublic()
  }
  async masksStaff(): Promise<Array<PersonTypeMask>> {
    return this.api.masksStaff()
  }
  async masksMember(): Promise<Array<PersonTypeMask>> {
    return this.api.masksMember()
  }
  async validateAssignedTypeStaff(person: PersonRef): Promise<PersonTypeValidation> {
    return this.api.validateAssignedTypeStaff(person)
  }
  async validatePersonStaff(request: PersonTypeRulesValidatePersonRequest): Promise<PersonTypeValidation> {
    return this.api.validatePersonStaff(request)
  }
}
